import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import DashboardSkeleton from '../../components/DashboardSkeleton';
import PromoterProfileSection from './PromoterProfileSection';
import PromoterEventsSection from './PromoterEventsSection';
import SentBookingsSection from './SentBookingsSection';

export default function PromoterDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [profile, setProfile] = useState(null);
  const [events, setEvents] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [editingEventIdFromUrl, setEditingEventIdFromUrl] = useState(null);
  const [bookingPreFill, setBookingPreFill] = useState(null);
  const [loading, setLoading] = useState(true);

  // Handle URL params for pre-opened forms
  useEffect(() => {
    const editEvent = searchParams.get('editEvent');
    const action = searchParams.get('action');
    const artistId = searchParams.get('artistId');
    const artistName = searchParams.get('artistName');

    if (editEvent) {
      // La section Événements ouvre l'édition quand ce state arrive
      setEditingEventIdFromUrl(editEvent);
      // Clear from URL to avoid re-triggers
      setSearchParams({}, { replace: true });
    }

    if (action === 'book' && artistId) {
      // La section Bookings ouvre le formulaire pré-rempli quand ce state arrive
      setBookingPreFill({ artistId, artistName });
      // Clear from URL
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [profileRes, eventsRes, bookingsRes] = await Promise.allSettled([
          api.get('/promoters/profile/me'),
          api.get('/events/mine'),
          api.get('/bookings/promoter/mine'),
        ]);
        if (profileRes.status === 'fulfilled') setProfile(profileRes.value.data.profile || profileRes.value.data);
        if (eventsRes.status === 'fulfilled') setEvents(eventsRes.value.data.events || []);
        if (bookingsRes.status === 'fulfilled') setBookings(bookingsRes.value.data.bookings || []);
      } catch {
        // Erreurs gérées individuellement
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) {
    return <DashboardSkeleton />;
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 animate-fadeIn">
      <h1 className="th-page-title mb-8">Dashboard Promoteur</h1>

      {/* Mon Profil */}
      <PromoterProfileSection profile={profile} onProfileChange={setProfile} />

      {/* Mes événements */}
      <PromoterEventsSection
        events={events}
        onEventsChange={setEvents}
        initialEditingEventId={editingEventIdFromUrl}
      />

      {/* Mes bookings envoyés */}
      <SentBookingsSection
        bookings={bookings}
        onBookingsChange={setBookings}
        events={events}
        bookingPreFill={bookingPreFill}
      />
    </div>
  );
}
